
namespace TabAurous.Reports {
    import fld = TabAurous.Retail.POSOrderItemsRow.Fields;
    //export class OpenConsignmentOutPanelOptions {
    //    items: TabAurous..ApprovalOutItemsRow[];
    //}

    //export class OpenConsignmentOutPanel extends Serenity.TemplatedPanel<OpenConsignmentOutPanelOptions> {
    //    constructor(container: JQuery, opt: OpenConsignmentOutPanelOptions) {
    //        super(container, opt);

    //        //Grouping
    //        var data = this.options.items;
    //        var code = [""];
    //        var grossamount = [0];
    //        code.pop();
    //        grossamount.pop();
    //        for (var i = 0; i < data.length; i++) {
    //            var checkexists = false;
    //            for (var j = 0; j < code.length; j++) {
    //                if (data[i].LedgerName.match(code[j])) {
    //                    checkexists = true;
    //                    grossamount[j] += data[i].GrossAmount;
    //                }
    //            }
    //            if (!checkexists) {
    //                code.push(data[i].LedgerName);
    //                grossamount.push(data[i].GrossAmount);
    //            }
    //        }
    //        var options = {
    //            chart: {
    //                height: 250,
    //                width: 430,
    //                type: 'line',
    //                fontFamily: '"PT Sans", sans-serif',
    //                zoom: {
    //                    enabled: false
    //                }
    //            },
    //            series: [
    //                {
    //                    name: '',
    //                    data: grossamount
    //                }
    //            ],

    //            stroke: {
    //                curve: 'straight'
    //            },
    //            xaxis: {
    //                categories: code
    //            }
    //        }
    //        //var x = document.getElementById('TabAurous_Reports_ChartPanel13_chartContainer');
    //        var y = container[0].childNodes[0];
    //        var chart = new ApexCharts(y, options);

    //        chart.render();
    //    }

    //    getTemplate() {

    //        return `<div id="~_chartContainer"></div>`;
    //    }
    //}

    
    @Serenity.Decorators.registerClass()
    export class POSOrderStatusGrid extends Serenity.EntityGrid<TabAurous.Retail.POSOrderItemsRow, any> {
        protected getColumnsKey() { return 'Retail.OrderStatus'; }
        protected getDialogType() { return TabAurous.Retail.POSOrderItemsDialog; }
        protected getIdProperty() { return TabAurous.Retail.POSOrderItemsRow.idProperty; }
        protected getInsertPermission() { return TabAurous.Retail.POSOrderItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return TabAurous.Retail.POSOrderItemsRow.localTextPrefix; }
        protected getService() { return TabAurous.Retail.OrderStatusService.baseUrl; }

        private chartContainer: JQuery;
        private chartPanel: Reports.LineChartPanel;
        constructor(container: JQuery) {
            super(container);

            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.FinancialYearRow.lookupKey,
                    multiple: true

                },
                field: 'FinancialYearId',
                title: 'Year',
                handler: w => {
                    var temp= [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).FinancialYearIds = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    }
                },
                
                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.CompanyRow.lookupKey,
                    multiple: true

                },
                field: 'CompanyId',
                title: 'Company',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).CompanyIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: "VendorLKUP",
                    multiple: true

                },
                field: 'PartyId',
                title: 'Party',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).VendorIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
          

            return filters;
        }

        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();


            // adding a specific css class to UnitPrice column, 
            // to be able to format cell with a different background
            Q.first(columns, x => x.field == fld.OrderStatus).cssClass += " col-status";

            return columns;
        }
        protected getItemCssClass(item: Retail.POSOrderItemsRow, index: number): string {
            let klass: string = "";

            if (item.Status == "Closed") {
                klass += " discontinued";
                klass += " closedorder";
            } else if (item.Status == "Open") {
                klass += " discontinued";
                klass += " openorder";
            } else if (item.Status == "In Process") {
                klass += " discontinued";
                klass += " inprocess";
            }

            
            return Q.trimToNull(klass);
        }

  /*      onViewProcessData(response: Serenity.ListResponse<TabAurous..ApprovalOutRow>) {

            if (!this.chartContainer) {
                this.chartContainer = $("<div style='padding: 20px 0' />");
                this.chartContainer.insertBefore(this.element.find(".grid-container"));
            }

            if (this.chartPanel) {
                this.chartPanel.destroy();
            }

            this.chartPanel = new ChartPanel(this.chartContainer, { items: response.Entities });

            var options = {
                chart: {
                    type: 'bar'
                },
                series: [
                    {
                        name: '',
                        data: [30, 40, 35, 50, 49, 60, 70, 91, 125]
                    }
                ],
                xaxis: {
                    categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999]
                }
            }

            var chart = new ApexCharts(document.querySelector(".chartContainer"), options);

            chart.render();


            return response;
        }
*/

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
            this.view.setGrouping([{

                getter: 'PosCustomerCode',
                displayTotalsRow: false,
            }])
            return grid;
        }

        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push({

                title: 'Print',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {
                    
                    Common.ReportHelper.execute({
                        reportKey: 'Reports.ApprovalRegister',
                        params: {
                            CompanyIds: this.view.params.CompanyIds,
                            FinIds: this.view.params.FinancialYearIds,
                            VendorIds: this.view.params.VendorIds,
                            date:this.view.params.Criteria
                        }
                    });
                }
            });
            return buttons;
        }
    }
}